import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useDraftStore } from '../../store/draftStore';

type DraftGateProps = {
  children: ReactNode;
};

/**
 * Wrapper para /review — só passa se o draft tiver todos os campos preenchidos
 * e moderação aprovada. Senão volta pra /register pro usuário completar.
 */
export function DraftGate({ children }: DraftGateProps) {
  const draft = useDraftStore((s) => s.draft);
  const isComplete =
    draft.displayName.trim().length > 0 &&
    draft.message.trim().length > 0 &&
    !!draft.photoDataUrl &&
    draft.moderation.status === 'approved';

  if (!isComplete) {
    return <Navigate to="/register" replace />;
  }
  return <>{children}</>;
}
